import * as types from './password-groups.types';

export const passwordGroupsPageSelectors: types.IPasswordGroupsPageSelectors = {
  selectPasswordGroupIds: (state) => state.page.passwordGroups.passwordGroupIds,
};
